import { render, staticRenderFns } from "./uploadImgJava.vue?vue&type=template&id=69330b58&"
import script from "./uploadImgJava.vue?vue&type=script&lang=js&"
export * from "./uploadImgJava.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports